export default "__VITE_ASSET__BoCnN4MF__"